// extracted by mini-css-extract-plugin
module.exports = {"slickPlaceholder":"style_slickPlaceholder__2Yd5y","placeholder":"style_placeholder__PA2IK","placeHolderShimmer":"style_placeHolderShimmer__2s9Wx"};